import { Col, Divider, Row, Space } from "antd";
import FB from "assets/logo/facebook.png";
import INSTA from "assets/logo/instagram.png";
import INTERNET from "assets/logo/internet.png";
import LINE from "assets/logo/line.png";
import TT from "assets/logo/tiktok.png";
import TWT from "assets/logo/twitter.png";
import { Input } from "components/form";

import styles from "./ContactInfo.module.css";
import { useTranslation } from "react-i18next";

const ContactInfo = ({ lower = null }) => {
  const { t } = useTranslation();

  return (
    <Space direction="vertical" size={6}>
      <b className={styles.infoTopic}>
        {t("company_profile.label.contact_information")}
      </b>
      <Divider />
      <Row gutter={[0, 16]}>
        <Col span={12} style={{ paddingRight: "12px" }}>
          <Input
            name="telNo"
            label={
              t("company_profile.label.tel_no")
            }
            placeholder={t("company_profile.label.tel_no")}
            size="large"
          />
        </Col>
        <Col span={12} style={{ paddingLeft: "12px" }}>
          <Input
            required
            name="phoneNo"
            label={
              t("company_profile.label.phone_no")
            }
            placeholder={t('phone-no')}
            size="large"
          />
        </Col>
        <Col span={12} style={{ paddingRight: "12px" }}>
          <Input
            required
            name="email"
            label={
              t("company_profile.label.email")
            }
            placeholder={t("company_profile.label.email")}
            size="large"
          />
        </Col>
        <Col span={12} style={{ paddingLeft: "12px" }}>
          <Input
            name="faxNo"
            label={
              t("company_profile.label.fax")
            }
            placeholder={t("company_profile.label.fax")}
            size="large"
          />
        </Col>
      </Row>
      <div className={styles.socialInfo}>
        <b className={styles.infoTopic}>
          {t("company_profile.label.social_media_information")}
        </b>
        <Divider />
        <Row gutter={[0, 16]}>
          <Col span={12} className={styles.socialRow} style={{ paddingRight: "12px" }}>
            <div className={styles.socialLogoContainer}>
              <img className={styles.socialLogo} src={FB} alt="Facebook logo" />
            </div>
            <Input name="facebook" placeholder="Facebook" size="large" />
          </Col>
          <Col span={12} className={styles.socialRow} style={{ paddingLeft: "12px" }}>
            <div className={styles.socialLogoContainer}>
              <img className={styles.socialLogo} src={TWT} alt="x logo" />
            </div>
            <Input name="x" placeholder="Twitter" size="large" />
          </Col>
          <Col span={12} className={styles.socialRow} style={{ paddingRight: "12px" }}>
            <div className={styles.socialLogoContainer}>
              <img
                className={styles.socialLogo}
                src={INSTA}
                alt="Instagram logo"
              />
            </div>
            <Input name="instagram" placeholder="Instargram" size="large" />
          </Col>
          <Col span={12} className={styles.socialRow} style={{ paddingLeft: "12px" }}>
            <div className={styles.socialLogoContainer}>
              <img className={styles.socialLogo} src={TT} alt="Tiktok logo" />
            </div>
            <Input name="tiktok" placeholder="Tiktok" size="large" />
          </Col>
          <Col span={12} className={styles.socialRow} style={{ paddingRight: "12px" }}>
            <div className={styles.socialLogoContainer}>
              <img className={styles.socialLogo} src={LINE} alt="Line logo" />
            </div>
            <Input name="lineId" placeholder="Line OA" size="large" />
          </Col>
          <Col span={12} className={styles.socialRow} style={{ paddingLeft: "12px" }}>
            <div className={styles.socialLogoContainer}>
              <img
                className={styles.socialLogo}
                src={INTERNET}
                alt="Internet logo"
              />
            </div>
            <Input name="website" placeholder="Website" size="large" />
          </Col>
        </Row>
      </div>
      {lower}
    </Space>
  );
};

export default ContactInfo;
